import { MeasurementData } from 'features/weather/types';
import {
  convertFromImperial,
  convertNumberToSaveToDB,
} from 'features/weather/utils/dataConverters';
import { WeatherConstraintForSubmission } from '../types';
import { WeatherConstraint as WeatherConstraintFromForm } from '../types';

export const convertConstraintsForAPICall = (
  weatherConstraints: WeatherConstraintFromForm[],
  inImperial: null | undefined | boolean
) => {
  const newConstraints: WeatherConstraintForSubmission[] = [];
  for (const constraint of weatherConstraints) {
    const measurement = constraint.measurement;
    if (measurement !== '') {
      newConstraints.push({
        ...constraint,
        measurement,
        level:
          convertFromImperial(
            convertNumberToSaveToDB(
              Number(constraint.level),
              constraint.measurement as MeasurementData
            ),
            constraint.measurement as MeasurementData,
            inImperial
          ) || 0,
      });
    }
  }
  return newConstraints;
};
